import RecordVideoPage from './record-video.page'

export default RecordVideoPage
